<template >
    <v-dialog v-model="open" :scrollable="$root.isTouch == false" fullscreen  persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> 
                <span class="white--text headline" v-html="objeto.titulo"></span>
                <v-spacer></v-spacer>
                <v-icon dark @click="close">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row dense class="mb-3">
                        <v-col cols="12">
                            
                            <v-window v-if="open" :key="renderKey" v-model="step" show-arrows show-arrows-on-hover>

                                <v-window-item :value="1">
                                    <windowDatosPolizaComponent :listGeneral="listGeneral"
                                                                :obModal="obModal"
                                    />
                                </v-window-item>

                                <v-window-item :value="2">
                                    <windowDatosPlanCoberturaComponent  :active="step == 2 ? true : false" 
                                                                        :listGeneral="listGeneral"
                                                                        :obModal="obModal"
                                    />
                                </v-window-item>

                                <v-window-item :value="3">
                                    <windowDatosDetallePlanCoberturaComponent  :active="step == 3 ? true : false" 
                                                                               :listGeneral="listGeneral"
                                                                               :obModal="obModal"
                                    />
                                </v-window-item>

                                <v-window-item :value="4">
                                    <windowDatosTasaComponent  :active="step == 4 ? true : false" 
                                                                :listGeneral="listGeneral"
                                                                :obModal="obModal"
                                    />
                                </v-window-item>

                                <v-window-item :value="5">
                                    <windowDatosCondicionParticularComponent  :active="step == 5 ? true : false" 
                                                                                :listGeneral="listGeneral"
                                                                                :obModal="obModal"
                                    />
                                </v-window-item>
                            </v-window>

                        </v-col>
                    </v-row>   
                </v-container>    
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        inject: ['close'],
        components:{
            windowDatosPolizaComponent: () => import('@/components/consulta/producto/windowDatosPolizaComponent.vue'),
            windowDatosPlanCoberturaComponent: () => import('@/components/consulta/producto/windowDatosPlanCoberturaComponent.vue'),
            windowDatosDetallePlanCoberturaComponent: () => import('@/components/consulta/producto/windowDatosDetallePlanCoberturaComponent.vue'),
            windowDatosTasaComponent: () => import('@/components/consulta/producto/windowDatosTasaComponent.vue'),
            windowDatosCondicionParticularComponent: () => import('@/components/consulta/producto/windowDatosCondicionParticularComponent.vue')
        },
        props:{
            open:{
                type:Boolean,
                default:false
            },
            objeto:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            step:1,
            obModal:{},
            listGeneral:{},
            renderKey:0,
        }),
        created(){
            if(this.open)
                this.cargaGeneral();
        },
        watch:{
            open(val){
                this.step = 1;
                this.obModal = {};
                // nueva referencia (reactiva) para que los windows no conserven datos del registro anterior
                this.listGeneral = {
                    detallePlanCob:[],
                    detalleDetPlanCob:[],
                    listCobertura:[],
                    detalleDocumentos:[]
                };
                // fuerza la recreación de los windows en cada llamado
                ++this.renderKey;
                if(val)
                    this.cargaGeneral();
            }
        },
        methods: {
            cargaGeneral(){
                if(!_.isUndefined(_.get(this.$refs,'form_aseguradora',undefined)))
                    this.$refs.form_aseguradora.resetValidation();
                
                var error = 'E';
                var o = _.merge({opcion:'L_DETALLE'},_.pick(this.objeto,'idPoliza'));
                this.obModal = {};

                axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                     .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                this.obModal = _.merge({},r.data.data[0],_.pick(this.objeto,['idProducto','idPoliza','producto']));
                    })
                    .catch((e) =>{
                            mensajesAlerta(e, error);
                    });
            },
            siguiente(){
                ++this.step;
            },
            setData(key,data,isObject=true){
                var c = _.get(this,key,{});
                if(isObject)
                    _.set(this,c,_.merge(c,data));
                else
                    _.set(this,key,data);
            }
        },
        provide(){
            return{
                siguiente:this.siguiente,
                setData:this.setData
            }
        }
    }
</script>

<style type="text/css">
    .v-window__next{
        display: none;
    }

    .btnNext:hover{
        color: #FF4132;
    }
</style>